import React from "react";
import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { INDIVIDUAL_PACKAGE_VALUE, UpdateElectricityAgreementPackageModalForm } from "../../models";
import { onNumberChange } from "helpers";
import { ELECTRICITY_PACKAGE_BASE_FIXATION_TYPES, ELECTRICITY_PACKAGE_EARLY_TERMINATION_FEE_TYPES, ElectricityPackageBaseFixationType, ElectricityPackageEarlyTerminationFeeType } from "components/ElectricityPackages/models";
import Select from "react-select";

interface UpdateElectricityAgreementPackageConsumptionPriceFormProps {
    form: UpdateElectricityAgreementPackageModalForm;
    setForm: (form: UpdateElectricityAgreementPackageModalForm) => void;
}

export default function UpdateElectricityAgreementPackageConsumptionPriceForm(
    { form, setForm } : UpdateElectricityAgreementPackageConsumptionPriceFormProps
) {
    const currentBaseFixationType = ELECTRICITY_PACKAGE_BASE_FIXATION_TYPES.find(p => p.value === form.consumptionPackage?.baseFixationType) || null;
    const currentEarlyTerminationFeeType = ELECTRICITY_PACKAGE_EARLY_TERMINATION_FEE_TYPES.find(p => p.value === form.consumptionPackage?.earlyTerminationFeeType) || null;
    const hasEarlyTerminationFee = !!form.consumptionPackage?.earlyTerminationFeeType;

    return (
        <>
            {
                form.consumptionPackage?.twoTariffPackage && (
                    <>
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <Form.Label>Päeva tariif (s/kWh)*</Form.Label>
                                <Form.Control
                                    value={form.consumptionPackage?.dayTariffCentsKwh}
                                    onChange={(e : any) => setForm({
                                            ...form,
                                            consumptionPackage: {
                                                ...form.consumptionPackage,
                                                dayTariffCentsKwh: onNumberChange(e)
                                            }
                                        })
                                    }
                                    required
                                    type="number"
                                    onWheel={(e: any) => e.target.blur()}
                                />
                                <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
                            </div>
                            <div className="col-12 col-md-6">
                            <Form.Label>Öö tariif (s/kWh)*</Form.Label>
                                <Form.Control
                                    value={form.consumptionPackage?.nightTariffCentsKwh}
                                    onChange={(e : any) => setForm({
                                            ...form,
                                            consumptionPackage: {
                                                ...form.consumptionPackage,
                                                nightTariffCentsKwh: onNumberChange(e)
                                            }
                                        })
                                    }
                                    required
                                    type="number"
                                    onWheel={(e: any) => e.target.blur()}
                                />
                                <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
                            </div>
                        </div>
                    </>
                )
            }
            {
                form.consumptionPackage?.dynamicPackage && (
                    <>
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <Form.Label>
                                    <span className="text-nowrap">Fikseerimise tüüp*</span>
                                </Form.Label>
                                <Select
                                        className={'form-select' + (form.validated && !form.consumptionPackage?.baseFixationType ? ' is-invalid' : '')} 
                                        options={ELECTRICITY_PACKAGE_BASE_FIXATION_TYPES}
                                        value={currentBaseFixationType}
                                        onChange={(val: any) => setForm({
                                            ...form,
                                            consumptionPackage: {
                                                ...form.consumptionPackage,
                                                baseFixationType: val.value
                                            }
                                        })}
                                        placeholder='Vali fikseerimise tüüp'
                                        required
                                        isDisabled={form.consumptionPackage?.id !== INDIVIDUAL_PACKAGE_VALUE}
                                    />
                                <Form.Control.Feedback className={'col-12 col-lg-8 offset-lg-3 pl-0'} type="invalid">Kohustuslik väli</Form.Control.Feedback>    
                            </div>
                            <div className="col-12 col-md-6">
                                <Form.Label>Fikseeritud tarbimise osakaal {form.consumptionPackage?.baseFixationType === ElectricityPackageBaseFixationType.PERCENTAGE ? "(%)" : "(MWh)"}</Form.Label>
                                <Form.Control
                                    value={form.consumptionPackage?.baseConsumptionProportion}
                                    onChange={(e : any) => setForm({
                                            ...form,
                                            consumptionPackage: {
                                                ...form.consumptionPackage,
                                                baseConsumptionProportion: onNumberChange(e)
                                            }
                                        })
                                    }
                                    required
                                    type="number"
                                    onWheel={(e: any) => e.target.blur()}
                                />
                                <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
                            </div>
                        </div>
                    </>
                )
            }
            <div className={`row ${form.consumptionPackage?.dynamicPackage || form.consumptionPackage?.twoTariffPackage ? "mt-3" : ""}`}>
                <div className="col-12 col-md-6">
                    <Form.Label>{form.consumptionPackage?.dynamicPackage ? 'Fikseeritud tarbimise hind KM-ta' : 'Baashind KM-ta'} (s/kWh)*</Form.Label>
                    <Form.Control
                        type="number"
                        disabled={form.consumptionPackage?.dynamicPackage || form.consumptionPackage?.marketPricePackage || form.consumptionPackage?.twoTariffPackage}
                        value={form.consumptionPackage?.basePriceCentsKwh ?? ''}
                        step={0.001}
                        onChange={(e: any) => setForm({
                            ...form, consumptionPackage: {
                                ...form.consumptionPackage,
                                basePriceCentsKwh: onNumberChange(e)
                            }
                        })}
                        required={!form.consumptionPackage?.marketPricePackage}
                        onWheel={(e: any) => e.target.blur()}
                    />
                    <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
                </div>
                <div className="col-12 col-md-6">
                    <Form.Label>Kuutasu KM-ta (€)</Form.Label>
                    <Form.Control
                        type="number"
                        value={form.consumptionPackage?.monthlyFeeEuros ?? ''}
                        step={0.001}
                        onChange={(e: any) => setForm({
                            ...form, consumptionPackage: {
                                ...form.consumptionPackage,
                                monthlyFeeEuros: onNumberChange(e)
                            }
                        })}
                        required
                        onWheel={(e: any) => e.target.blur()}
                    />
                    <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
                </div>                  
            </div>
            <div className="row mt-3">
                <div className="col-12 col-md-6">
                    <Form.Label>{form.consumptionPackage?.dynamicPackage ? 'Börsihinnaga tarbimise marginaal KM-ta' : 'Marginaal KM-ta'} (s/kWh)*</Form.Label>
                    <Form.Control
                        required
                        type="number"
                        value={form.consumptionMarginal}
                        step={0.001}
                        onChange={(e: any) => setForm({
                            ...form,
                            consumptionMarginal: onNumberChange(e)
                        })}
                        onWheel={(e: any) => e.target.blur()}
                    />
                    <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>
                </div>
                {
                    form.consumptionPackage?.id === INDIVIDUAL_PACKAGE_VALUE && (
                        <div className="col-12 col-md-6">
                            <Form.Label>
                                {form.consumptionPackage?.dynamicPackage ? 'Fikseeritud tarbimise hinna tekst' : 'Baashinna tekst'}
                                <OverlayTrigger delay={250}
                                    overlay={
                                        <Tooltip id={`tooltip-base-price-text`}>
                                            <p className='m-1'>Kuvatakse {form.consumptionPackage?.dynamicPackage ? 'fikseeritud tarbimise hinna' : 'baashinna'} all või asemel, kui hind puudub<br />(nt Tootmishind + marginaal)</p>
                                        </Tooltip>} placement={"right"}>
                                        <i className='icon__info icon__info--masked bg-dark ml-2 mb-n1'></i>
                                </OverlayTrigger>
                            </Form.Label>
                            <Form.Control
                                disabled={true}
                                value={form.consumptionPackage?.basePriceTextEt}
                                onChange={(e: any) => setForm({
                                    ...form, consumptionPackage: {
                                        ...form.consumptionPackage,
                                        basePriceTextEt: e.target.value
                                    }
                                })}
                                required={form.consumptionPackage?.marketPricePackage}
                            />
                        </div>
                    )
                }
            </div>
            {
                form.consumptionPackage?.id === INDIVIDUAL_PACKAGE_VALUE && (
                <div className="row mt-3">
                    <div className="col-12 col-md-6">
                        <Form.Label>
                            {form.consumptionPackage.dynamicPackage ? 'Fikseeritud tarbimise hinna eestikeelne tekst' : 'Baashinna eestikeelne tekst'}
                            <OverlayTrigger delay={250}
                                overlay={
                                    <Tooltip id={`tooltip-base-price-text`}>
                                        <p className='m-1'>Kuvatakse {form.consumptionPackage.dynamicPackage ? 'fikseeritud tarbimise hinna' : 'baashinna'} all või asemel, kui hind puudub<br />(nt Tootmishind + marginaal)</p>
                                    </Tooltip>} placement={"right"}>
                                    <i className='icon__info icon__info--masked bg-dark ml-2 mb-n1'></i>
                            </OverlayTrigger>
                        </Form.Label>
                        <Form.Control
                            value={form.consumptionPackage?.basePriceTextEt}
                            onChange={(e: any) => setForm({
                                ...form, consumptionPackage: {
                                    ...form.consumptionPackage,
                                    basePriceTextEt: e.target.value
                                }
                            })}
                            required={form.consumptionPackage?.marketPricePackage}
                        />
                    </div>
                    <div className="col-12 col-md-6">
                        <Form.Label>
                        {form.consumptionPackage.dynamicPackage ? 'Fikseeritud tarbimise hinna inglisekeelne tekst' : 'Baashinna inglisekeelne tekst'}
                        </Form.Label>
                        <Form.Control
                            value={form.consumptionPackage?.basePriceTextEn}
                            onChange={(e: any) => setForm({
                                ...form, consumptionPackage: {
                                    ...form.consumptionPackage,
                                    basePriceTextEn: e.target.value
                                }
                            })}
                            required={form.consumptionPackage?.marketPricePackage}
                        />
                    </div>
                </div>
                )
            }
            {
                (hasEarlyTerminationFee || form.consumptionPackage?.id === INDIVIDUAL_PACKAGE_VALUE) && (
                    <>
                        <div className="row mt-3">
                            <div className="col-12 col-md-6">
                                <Form.Label>
                                    <span className="text-nowrap">Ennetähtaegse lõpetamise tasu tüüp</span>
                                </Form.Label>
                                <Select
                                        className="form-select" 
                                        options={ELECTRICITY_PACKAGE_EARLY_TERMINATION_FEE_TYPES}
                                        value={currentEarlyTerminationFeeType}
                                        onChange={(val: any) => setForm({
                                            ...form,
                                            consumptionPackage: {
                                                ...form.consumptionPackage,
                                                earlyTerminationFeeType: val?.value ?? null,
                                                earlyTerminationFee: undefined
                                            },
                                            estimatedConsumptionVolumeMwh: undefined
                                        })}
                                        isClearable
                                        placeholder=""
                                        isDisabled={form.consumptionPackage?.id !== INDIVIDUAL_PACKAGE_VALUE}
                                    />
                            </div>
                            {
                                hasEarlyTerminationFee && form.consumptionPackage?.earlyTerminationFeeType === ElectricityPackageEarlyTerminationFeeType.FIXED_PER_LEFTOVER_MONTH && (
                                    <div className="col-12 col-md-6">
                                        <Form.Label>
                                            Lõpetamise tasu KM-ta (€)*
                                        </Form.Label>
                                        <Form.Control
                                            value={form.consumptionPackage?.earlyTerminationFee}
                                            onChange={(e: any) => setForm({
                                                    ...form,
                                                    consumptionPackage: {
                                                        ...form.consumptionPackage,
                                                        earlyTerminationFee: onNumberChange(e)
                                                    }
                                                })
                                            }
                                            step={0.001}
                                            type="number"
                                            required
                                            onWheel={(e: any) => e.target.blur()}
                                        />
                                        <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>  
                                    </div>
                                )
                            }
                        </div>
                        {
                                hasEarlyTerminationFee && form.consumptionPackage?.earlyTerminationFeeType === ElectricityPackageEarlyTerminationFeeType.PERCENTAGE_OF_VOLUME && (
                                    <>
                                        <div className="row mt-3">
                                            <div className="col-12 col-md-6">
                                                <Form.Label>
                                                    Tarbimismahu protsent (%)*
                                                </Form.Label>
                                                <Form.Control
                                                    value={form.consumptionPackage?.earlyTerminationFee}
                                                    onChange={(e: any) => setForm({
                                                            ...form,
                                                            consumptionPackage: {
                                                                ...form.consumptionPackage,
                                                                earlyTerminationFee: onNumberChange(e)
                                                            }
                                                        })
                                                    }
                                                    type="text"
                                                    required
                                                    onWheel={(e: any) => e.target.blur()}
                                                />
                                                <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>  
                                            </div>
                                            {
                                                !form.consumptionPackage.twoTariffPackage && (
                                                    <div className="col-12 col-md-6">
                                                        <Form.Label>
                                                            Hinnanguline tarbimise maht (MWh)*
                                                        </Form.Label>
                                                        <Form.Control
                                                            value={form?.estimatedConsumptionVolumeMwh}
                                                            onChange={(e: any) => setForm({
                                                                    ...form,
                                                                    estimatedConsumptionVolumeMwh: onNumberChange(e)
                                                                })
                                                            }
                                                            step={0.001}
                                                            type="number"
                                                            required
                                                            onWheel={(e: any) => e.target.blur()}
                                                        />
                                                        <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>  
                                                    </div>
                                                )
                                            }
                                        </div>
                                        {
                                            form.consumptionPackage.twoTariffPackage && (
                                                <div className="row mt-3">
                                                    <div className="col-12 col-md-6">
                                                        <Form.Label>
                                                            Hinnanguline päeva tarbimise maht (MWh)*
                                                        </Form.Label>
                                                        <Form.Control
                                                            value={form?.estimatedConsumptionDayVolumeMwh}
                                                            onChange={(e: any) => setForm({
                                                                    ...form,
                                                                    estimatedConsumptionDayVolumeMwh: onNumberChange(e)
                                                                })
                                                            }
                                                            step={0.001}
                                                            type="number"
                                                            required
                                                            onWheel={(e: any) => e.target.blur()}
                                                        />
                                                        <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>  
                                                    </div>
                                                    <div className="col-12 col-md-6">
                                                        <Form.Label>
                                                            Hinnanguline öine tarbimise maht (MWh)*
                                                        </Form.Label>
                                                        <Form.Control
                                                            value={form?.estimatedConsumptionNightVolumeMwh}
                                                            onChange={(e: any) => setForm({
                                                                    ...form,
                                                                    estimatedConsumptionNightVolumeMwh: onNumberChange(e)
                                                                })
                                                            }
                                                            step={0.001}
                                                            type="number"
                                                            required
                                                            onWheel={(e: any) => e.target.blur()}
                                                        />
                                                        <Form.Control.Feedback className={'text-right'} type="invalid">Kohustuslik väli</Form.Control.Feedback>  
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </>
                                )
                            }
                    </>
                )
            }
        </>
    );
}